import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Application} from './_models'

const getBaseUrl = () => {
  let url = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  if (url === 'http://localhost:3000') url = 'http://localhost:3000/api';
  return url;
}
const API_URL = getBaseUrl() + '/application'

const updateApplication = (app: Application): Promise<Application | undefined> => {
  return axios.patch(`${API_URL}/${app.id}`, app)
}

const deleteApplication = (appId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${appId}`)
}

export {deleteApplication, updateApplication}
